import styled from 'styled-components'

import dots from '../../images/dots.png'
import { rspTheme } from '../../styles/rspTheme'
import {
  BackgroundGradient,
  ContentContainer,
  SlideContainer,
} from '../TrainstopImageSlide/styles'

export const TrainstopSectionContainer = styled.section`
  position: relative;

  &.light {
    color: ${rspTheme.palette.primary.main};
    background-color: ${rspTheme.palette.secondary.background};
  }
  &.dark {
    color: #ffffff;
    background-color: ${rspTheme.palette.primary.dark};
  }

  &.impactSlides {
    background-image: url(${dots});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top center;
  }

  &.technology {
    max-height: 675px;
    background: rgb(82, 70, 119);
    background: radial-gradient(
      circle,
      rgba(82, 70, 119, 1) 0%,
      rgba(13, 2, 48, 1) 83%
    );

    @media screen and (max-width: ${rspTheme.breakpoints.values.smmd}px) {
      ${ContentContainer} {
        padding: 32px 0;
      }
      ${SlideContainer} {
        max-height: 675px;
        min-height: 600px;
      }
      ${BackgroundGradient} {
        display: none;
      }
    }
  }

  .subhead {
    color: inherit;
    margin: 48px 0 0;
    max-width: 20ch;
  }

  .slidesContainer {
    position: relative;
    min-height: 650px;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    overflow: hidden;

    .slideContainer {
      grid-column: 1 / -1;
      grid-row: 1 / -1;
    }

    @media (max-width: ${rspTheme.breakpoints.values.smmd}px) {
      min-height: 540px;
    }
  }
`

export const HeadlineContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 30;
`

export const HeroTrainstopHeadline = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 72px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  .heroTrainstopSubhead {
    color: inherit;
    width: 50%;
    max-width: 18ch;
  }

  @media (max-width: 980px) {
    justify-content: flex-start;
    top: 2.8rem;

    .heroTrainstopSubhead {
      width: 100%;
      max-width: 24ch;
      font-size: 2.4rem;
      max-width: unset;
    }
  }
`

export const ControlContainer = styled.div`
  position: absolute;
  z-index: 30;
  bottom: 0;
  left: 0;
  right: 0;

  @media (max-width: 768px) {
    bottom: -25px;
  }
`
